import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M22.5,7.5c0,0.2,0,0.5,0,0.6c0,6.7-5.2,14.7-14.7,14.7c-3,0-5.6-0.8-7.8-2.3c0.5,0,0.8,0,1.3,0c2.3,0,4.7-0.8,6.4-2.2 c-2.2,0-4.2-1.6-4.8-3.6c0.3,0,0.6,0.2,0.9,0.2c0.5,0,0.9,0,1.4-0.2c-2.3-0.5-4.1-2.5-4.1-5l0,0c0.8,0.5,1.6,0.6,2.3,0.6 C2,9.4,1.1,7.8,1.1,6.1c0-0.9,0.3-1.9,0.6-2.7C4.2,6.6,8,8.6,12.3,8.8c-0.2-0.3-0.2-0.8-0.2-1.1c0-2.8,2.3-5.2,5.2-5.2 c1.4,0,2.8,0.6,3.8,1.6c1.1-0.2,2.2-0.6,3.3-1.3C23.9,4.1,23.1,5,22,5.6c1.1-0.2,2-0.5,3-0.8C24.4,5.9,23.4,6.9,22.5,7.5z" />
    </g>
  </svg>
);
